import Vue from 'vue';
import Terms from '~/pages/terms.vue';
import RasylvaApi from '~/plugins/rasylva-api';

Vue.use(RasylvaApi);

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('terms-wrapper')) {
    new Vue({
      render: (h) => h(Terms),
    }).$mount('#terms-wrapper');
  }
});
